import { useAnalytics } from "@codat/analytics";
import { ModalBody as OrchardModalBody } from "@codat/orchard-ui";
import { ModalBodyProps as OrchardModalBodyProps } from "@codat/orchard-ui/dist/es/components/ModalBody";
import * as React from "react";

interface ModalBodyWithTrackingProps
  extends Omit<OrchardModalBodyProps, "ref"> {
  eventProperties?: Record<string, unknown>;
}

const ModalBody = React.forwardRef<HTMLDivElement, ModalBodyWithTrackingProps>(
  function ModalBody(props: ModalBodyWithTrackingProps, ref) {
    const { onClose, eventProperties, ...modalBodyWithTrackingProps } = props;
    const { sendEvent } = useAnalytics();

    const handleOnClose = () => {
      sendEvent("Close Icon - Click", eventProperties);
      if (onClose) {
        onClose();
      }
    };

    return (
      <OrchardModalBody
        onClose={handleOnClose}
        {...modalBodyWithTrackingProps}
        ref={ref}
      >
        {props.children}
      </OrchardModalBody>
    );
  }
);

export default ModalBody;
